/* tslint:disable */
/* eslint-disable */
/**
 * radia.cz
 * Seznam endpointu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontWebSongProgramModel
 */
export interface FrontWebSongProgramModel {
    /**
     * Interpret
     * @type {string}
     * @memberof FrontWebSongProgramModel
     */
    interpret: string;
    /**
     * Song
     * @type {string}
     * @memberof FrontWebSongProgramModel
     */
    song: string;
    /**
     * Time
     * @type {number}
     * @memberof FrontWebSongProgramModel
     */
    time?: number;
    /**
     * Začátek
     * @type {string}
     * @memberof FrontWebSongProgramModel
     */
    beginAt: string;
}

/**
 * Check if a given object implements the FrontWebSongProgramModel interface.
 */
export function instanceOfFrontWebSongProgramModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "interpret" in value;
    isInstance = isInstance && "song" in value;
    isInstance = isInstance && "beginAt" in value;

    return isInstance;
}

export function FrontWebSongProgramModelFromJSON(json: any): FrontWebSongProgramModel {
    return FrontWebSongProgramModelFromJSONTyped(json, false);
}

export function FrontWebSongProgramModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontWebSongProgramModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'interpret': json['interpret'],
        'song': json['song'],
        'time': !exists(json, 'time') ? undefined : json['time'],
        'beginAt': json['beginAt'],
    };
}

export function FrontWebSongProgramModelToJSON(value?: FrontWebSongProgramModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'interpret': value.interpret,
        'song': value.song,
        'time': value.time,
        'beginAt': value.beginAt,
    };
}

